import MailingList from "./mailinglist";

export default MailingList;
